import { AlertListComponent } from './alert-list/alert-list.component';
import { ScrollFadeDirective } from './scroll-fade/scroll-fade.directive';
import { GlobalSearchComponent } from './global-search/global-search.component';
export type { AlertTab } from './alert-list/alert-list.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { SourceBadgeComponent } from './source-badge/source-badge.component';
import { SourceSummaryComponent } from './source-badge/source-summary.component';
import { ValueSourcePipe } from './source-badge/value-source.pipe';
import { ActionListComponent } from './action-list/action-list.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SideMenuLayoutComponent } from './side-menu-layout/side-menu-layout.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { UnauthenticatedComponent } from './unauthenticated/unauthenticated.component';
import { ListEditorComponent } from './list-editor/list-editor.component';
import { CompaniesSearchComponent } from './companies-search/companies-search.component';
import { CompaniesFilterComponent } from './companies-filter/companies-filter.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AddToListButtonComponent } from './add-to-list-button/add-to-list-button.component';
import { LoadPanelComponent } from './load-panel/load-panel.component';
import { GridErrorComponent } from './grid-error/grid-error.component';
import {
  GridCellDirective,
  LocalGridComponent,
} from './local-grid/local-grid.component';
import {
  DialogComponent,
  DialogFooterDirective,
} from './dialog/dialog.component';
import { OverlayPanelComponent } from './overlay-panel/overlay-panel.component';
import { QueryBarComponent } from './query-bar/query-bar.component';
import { ListTypeIconComponent } from './list-type-icon/list-type-icon.component';
import { ShortcutHelpComponent } from './shortcut-help/shortcut-help.component';
import { NumberInputComponent } from './number-input/number-input.component';
import { SelectComponent } from './select/select.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { ChipsComponent } from './chips/chips.component';
import { DateInputComponent } from './date-input/date-input.component';
import { ColumnResizerDirective } from './table/column-resizer.directive';
import { ContextMenuComponent } from './table/context-menu.component';
import { PaginatorComponent } from './table/paginator.component';
import {
  IncrementalRows,
  LoadMoreDirective,
  RENDER_STEP,
} from './table/load-more.directive';
import { SortIconComponent } from './table/sort-icon.component';
import { TableCheckboxComponent } from './table/table-checkbox.component';
import { TooltipDirective } from './table/tooltip.directive';
import { VirtualRowsDirective } from './table/virtual-rows.directive';
import { MultiSelectComponent } from './select/multi-select.component';
import { SelectTemplateDirective } from './select/select-options';
import { SearchElapsedComponent } from './search-elapsed/search-elapsed.component';

/** Standalone building blocks, imported rather than declared. */
const standaloneComponents = [
  ColumnResizerDirective,
  ScrollFadeDirective,
  ContextMenuComponent,
  PaginatorComponent,
  LoadMoreDirective,
  VirtualRowsDirective,
  SortIconComponent,
  TableCheckboxComponent,
  TooltipDirective,
  AutocompleteComponent,
  ChipsComponent,
  DateInputComponent,
  DialogComponent,
  DialogFooterDirective,
  MultiSelectComponent,
  NumberInputComponent,
  OverlayPanelComponent,
  SelectComponent,
  SelectTemplateDirective,
  SearchElapsedComponent,
  ListTypeIconComponent,
];

const sharedComponents = [
  AlertListComponent,
  GlobalSearchComponent,
  PageHeaderComponent,
  SourceBadgeComponent,
  SourceSummaryComponent,
  ValueSourcePipe,
  ListEditorComponent,
  ActionListComponent,
  SideMenuLayoutComponent,
  SideMenuComponent,
  HeaderComponent,
  FooterComponent,
  UnauthenticatedComponent,
  CompaniesSearchComponent,
  CompaniesFilterComponent,
  QueryBarComponent,
  ShortcutHelpComponent,
  ChangePasswordComponent,
  AddToListButtonComponent,
  LoadPanelComponent,
  GridErrorComponent,
  GridCellDirective,
  LocalGridComponent,
];

export {
  sharedComponents,
  standaloneComponents,
  IncrementalRows,
  RENDER_STEP,
  ListTypeIconComponent,
  ColumnResizerDirective,
  ScrollFadeDirective,
  ContextMenuComponent,
  PaginatorComponent,
  LoadMoreDirective,
  VirtualRowsDirective,
  SortIconComponent,
  TableCheckboxComponent,
  TooltipDirective,
  AutocompleteComponent,
  ChipsComponent,
  DateInputComponent,
  DialogComponent,
  DialogFooterDirective,
  MultiSelectComponent,
  NumberInputComponent,
  OverlayPanelComponent,
  SelectComponent,
  SelectTemplateDirective,
  SearchElapsedComponent,
  ListEditorComponent,
  AlertListComponent,
  GlobalSearchComponent,
  PageHeaderComponent,
  SourceBadgeComponent,
  SourceSummaryComponent,
  ValueSourcePipe,
  ActionListComponent,
  SideMenuLayoutComponent,
  SideMenuComponent,
  HeaderComponent,
  FooterComponent,
  UnauthenticatedComponent,
  CompaniesSearchComponent,
  CompaniesFilterComponent,
  QueryBarComponent,
  ShortcutHelpComponent,
  ChangePasswordComponent,
  AddToListButtonComponent,
  LoadPanelComponent,
  GridErrorComponent,
  GridCellDirective,
  LocalGridComponent,
};

export type { GridColumn } from './local-grid/local-grid.component';
export type { ColumnResizeEvent } from './table/column-resizer.directive';
export type { QueryChange } from './query-bar/query-bar.component';
export { DEFAULT_PRESETS } from './query-bar/query-suggestions';
export type { QueryPreset } from './query-bar/query-suggestions';
export {
  RowSelection,
  restoreIndex,
  restoreLastOpened,
} from './table/endless-rows';
export { rowRange } from './table/virtual-rows.directive';
